import request from '@/api/request'

export default {
  async saveMatch (sku, body) {
    return (await request.post(`module/action/marketplace/cnova/match/save/${sku}`, body)).data
  },
  /**
   * Retorna as razões de excluir produto.
   *
   * @returns {Promise.<Object>}
   */
  async getReasonsToDelete () {
    return (await request.get(`module/action/marketplace/cnova/product/reasonsDelete`)).data
  },
  /**
   * Retorna as razões de excluir produto.
   *
   * @returns {Promise.<Object>}
   */
  async deleteProduct (product, reason) {
    return (await request.post(`module/action/marketplace/cnova/product/delete/` + product.sku, {
      params: reason
    })).data
  },
  /**
   * Retorna as categorias com garantia obrigatória.
   *
   * @returns {Promise.<Object>}
   */
  async getCategoriesWithWarranty () {
    return (await request.get(`module/action/marketplace/cnova/category/withWarranty`)).data
  }
}



// WEBPACK FOOTER //
// ./src/api/marketplace/cnova/index.js